import React, {useRef, useEffect} from 'react'

type Props = {
  value: string
  onChange: (value: string) => void
  length?: number
}

export function MfaCodeInput({value, onChange, length = 6}: Props) {
  const refs = useRef<(HTMLInputElement | null)[]>([])

  useEffect(() => {
    refs.current = refs.current.slice(0, length)
  }, [length])

  const digits = value.padEnd(length, ' ').slice(0, length).split('')

  const handleChange = (index: number, char: string) => {
    const digit = char.replace(/\D/g, '').slice(-1)
    const next = digits.map((d, i) => (i === index ? digit : d.trim())).join('').replace(/\s/g, '')
    onChange(next.slice(0, length))
    if (digit && index < length - 1) refs.current[index + 1]?.focus()
  }

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !digits[index]?.trim() && index > 0) {
      refs.current[index - 1]?.focus()
    }
  }

  return (
    <div className='d-flex gap-2 justify-content-center'>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => {
            refs.current[i] = el
          }}
          type='text'
          inputMode='numeric'
          maxLength={1}
          className='form-control text-center fs-3 fw-bold'
          style={{width: 48, height: 56}}
          value={d.trim()}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
        />
      ))}
    </div>
  )
}
